/**
 * AUTO-GENERATED FILE, DO NOT EDIT!
 * =================================
 * This file is automatically generated through the Figma API. If you want to
 * add an elevation token, let the DS team know through a Jira ticket. Manual
 * additions will be automatically overwritten.
 */
var elevationTokens = {
  /**
   * elevation--overlay
   * ------------------
   */
  'elevation--overlay': '0px 1px 2px 0px rgba(79, 82, 104, 0.24), 0px 1px 8px 0px rgba(79, 82, 104, 0.08), 0px 1px 16px 4px rgba(79, 82, 104, 0.1)',
  /**
   * elevation--overlay-inverted
   * ---------------------------
   */
  'elevation--overlay-inverted': '0px 1px 2px 0px rgba(0, 0, 0, 0.4), 0px 1px 8px 0px rgba(0, 0, 0, 0.3), 0px 1px 16px 4px rgba(0, 0, 0, 0.3)',
  /**
   * elevation--surface--interactive
   * -------------------------------
   */
  'elevation--surface--interactive': '0px 1px 1px 0px rgba(79, 82, 104, 0.1), 0px 1px 8px 0px rgba(79, 82, 104, 0.1)',
  /**
   * elevation--surface--interactive--hover
   * --------------------------------------
   */
  'elevation--surface--interactive--hover': '0px 2px 6px 1px rgba(79, 82, 104, 0.12), 0px 6px 20px 2px rgba(79, 82, 104, 0.06)',
  /**
   * elevation--surface--interactive--hover-inverted
   * -----------------------------------------------
   */
  'elevation--surface--interactive--hover-inverted': '0px 2px 6px 1px rgba(0, 0, 0, 0.4), 0px 6px 20px 2px rgba(0, 0, 0, 0.3)',
  /**
   * elevation--surface--interactive-inverted
   * ----------------------------------------
   */
  'elevation--surface--interactive-inverted': '0px 1px 1px 0px rgba(0, 0, 0, 0.2), 0px 1px 8px 0px rgba(0, 0, 0, 0.3)',
  /**
   * elevation--surface--non-interactive
   * -----------------------------------
   */
  'elevation--surface--non-interactive': '0px 1px 2px 1px rgba(79, 82, 104, 0.04), 0px 1px 1px 1px rgba(79, 82, 104, 0.06)',
  /**
   * elevation--surface--non-interactive-inverted
   * --------------------------------------------
   */
  'elevation--surface--non-interactive-inverted': '0px 1px 2px 1px rgba(0, 0, 0, 0.2), 0px 1px 1px 1px rgba(0, 0, 0, 0.3)'
};

export { elevationTokens };
